// extracted by mini-css-extract-plugin
export default {"fs":"_0cd0d713ff _04368a2044"};